import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";
import type { HTMLAttributes, PropsWithChildren } from "react";

const linkButtonStyles = (theme: ExactTheme) => css`
  color: ${theme.colorsV2.cyan[500]};
  font-size: ${theme.fontSizesV2.body};
  font-weight: ${theme.fontWeights.normal};
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const LinkButton = ({
  children,
  ...restProps
}: PropsWithChildren<HTMLAttributes<HTMLButtonElement>>) => {
  return (
    <button {...restProps} css={linkButtonStyles}>
      {children}
    </button>
  );
};
